import {HsvColor, RgbColor} from './colorTypes';

/**
 * @name hsvToRgb
 * @description Converts an HSV object into an RGB object
 *              This function is taken from here https://gist.github.com/mjackson/5311256
 *              hence the horrible variable names
 */
export const hsvToRgb = (hsv: HsvColor): RgbColor => {
  const h = hsv.h / 360;
  const s = hsv.s;
  const v = hsv.v;

  const i = (h * 6) | 0;
  const f = h * 6 - i;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);

  let r = 0;
  let g = 0;
  let b = 0;

  switch (i % 6) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = p;
      g = v;
      b = t;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    default:
      r = v;
      g = p;
      b = q;
      break;
  }
  return {
    // eslint-disable-next-line
    r: (0.5 + (r * 255)) | 0,
    // eslint-disable-next-line
    g: (0.5 + (g * 255)) | 0,
    // eslint-disable-next-line
    b: (0.5 + (b * 255)) | 0,
    a: 1,
  };
};
